import script from "./Sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=d470d01c&lang=css"

const __exports__ = script;

export default __exports__